module.exports = __webpack_public_path__ + "img/BLOCKCHAIN.5ae42555.png";